import { useState } from "react";

// Define default URLs for different services
const defaultAiApiUrl = "http://192.168.1.21:8000"; // Localized Python AI backend
const defaultBillingApiUrl = "https://xeoxvk3jxlmq9npf.vercel.app/"; // Vercel server for billing

let aiApiUrl = defaultAiApiUrl;
let billingApiUrl = defaultBillingApiUrl;

// Functions to set and get AI API URL
export const setAiApiUrl = (newUrl) => {
  aiApiUrl = newUrl;
};

export const getAiApiUrl = () => aiApiUrl;

// Functions to set and get Billing API URL
export const setBillingApiUrl = (newUrl) => {
  billingApiUrl = newUrl;
};

export const getBillingApiUrl = () => billingApiUrl;

// Hook to manage API URLs dynamically
export const useApiUrl = (service) => {
  const [currentApiUrl, setCurrentApiUrl] = useState(
    service === "billing" ? billingApiUrl : aiApiUrl
  );

  const updateApiUrl = (newUrl) => {
    if (service === "billing") {
      setBillingApiUrl(newUrl);
    } else {
      setAiApiUrl(newUrl);
    }
    setCurrentApiUrl(newUrl);
  };

  return [currentApiUrl, updateApiUrl];
};
